export default "__VITE_ASSET__BpAxeTl2__"